<script>
    export default {
        name: "PaymentIcons",
        props: {
            isLight: Boolean,
            exclude: String,
        },
        computed: {
            icons() {
                const postfix = this.isLight ? "--light" : "";
                return [
                    { title: "Наличные", image: "cash.png" },
                    { title: "Mir", image: "mir.svg" },
                    { title: "Visa", image: `visa${postfix}.svg` },
                    { title: "Mastercard", image: `mastercard${postfix}.svg` },
                    { title: "Yandex Pay", image: `ypay${postfix}.svg` },
                ].filter((icon) => icon.title !== this.exclude);
            },
        },
    };
</script>

<template>
    <div class="payment-icons">
        <div class="payment-icons__list">
            <div class="payment-icons__item" v-for="(icon, index) in icons" :key="index">
                <img :src="`/static/assets/payment/${icon.image}`" :alt="icon.title" />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .payment-icons {
        max-width: 330px;
        text-align: center;
    }

    .payment-icons__list {
        display: flex;
        margin: 0 -4px;
    }

    .payment-icons__item {
        flex-grow: 1;
        max-width: 48px;
        margin: 0 4px;
        box-sizing: border-box;
    }
</style>
